module.exports = __webpack_public_path__ + "assets/img/1_1092_big.538fc535.jpg";